module.exports = __webpack_public_path__ + "static/chimamanda-ngozi-adichie-12b591a55c533c69167c40fbf34f2fa7.jpg";